<template>
  <nav class="sidebar">
    <div class="sidebar-header">
      <a href="/" class="sidebar-brand">
        <img src="../../assets/img/title_lms.gif" style="width: 200px" alt="" />
      </a>
    </div>
    <div class="sidebar-body">
      <ul class="nav" style="padding-left:0;">
        <li class="nav-item">
          <a href="/videos" target="_self" class="nav-link">
            <i class="link-icon" data-feather="phone"></i>
            <span
              :class="{
                'pick-inc-menu':
                  $router.currentRoute.name === 'Videos' ||
                  $router.currentRoute.name === 'VideoAdd' ||
                  $router.currentRoute.name === 'VideoModify'
              }"
              class="link-title font-weight-light"
              >동영상 뉴스</span
            >
          </a>
        </li>
        <li class="nav-item">
          <a href="/reuters" target="_self" class="nav-link">
            <i class="link-icon" data-feather="edit"></i>
            <span
              :class="{
                'pick-inc-menu':
                  $router.currentRoute.name === 'Reuters' ||
                  $router.currentRoute.name === 'ReutersAdd' ||
                  $router.currentRoute.name === 'ReutersModify'
              }"
              class="link-title font-weight-light"
              >로이터 지식서비스</span
            >
          </a>
        </li>
        <li class="nav-item">
          <a href="/pick4u" target="_self" class="nav-link">
            <i class="link-icon" data-feather="edit"></i>
            <span
              :class="{
                'pick-inc-menu':
                  $router.currentRoute.name === 'Pick4u' ||
                  $router.currentRoute.name === 'Pick4uVideo' ||
                  $router.currentRoute.name === 'Pick4uDetail'
              }"
              class="link-title font-weight-light"
              >픽포유</span
            >
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/booklist">
            <i class="link-icon" data-feather="edit"></i>
            <span
              :class="{
                'pick-inc-menu':
                  $router.currentRoute.name === 'BookList' ||
                  $router.currentRoute.name === 'BookAdd' ||
                  $router.currentRoute.name === 'BookModify'
              }"
              class="link-title font-weight-light"
              >교재관리</span
            >
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/editor">
            <i class="link-icon" data-feather="edit"></i>
            <span :class="{ 'pick-inc-menu' : $router.currentRoute.name === 'Editor'  }" class="link-title font-weight-light">이미지 링크 에디터</span>
          </a>
        </li>
        <li class="nav-item" style="bottom: 0">
          <a
            href="#"
            onclick="return false;"
            target="_self"
            class="nav-link"
            @click="logout()"
          >
            <i class="link-icon" data-feather="edit"></i>
            <span class="link-title font-weight-light">로그아웃</span>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import router from "@/router";

export default {
  name: "incHead",
  props: {
    visible: {
      type: Boolean,
      require: true,
      default: false
    }
  },

  data: () => ({}),

  mounted() {},

  methods: {
    logout: function() {
      if (confirm("정말로 로그아웃 하시겠습니까?") === true) {
        const params = {};
        this.axios
          .get("/login/out", {
            params: params,
            headers: {
              authorization: localStorage.getItem("authorization")
            }
          })
          .then(function(res) {
            console.log(res);
            if (res.data.status === 0) {
              localStorage.removeItem("authorization");
              localStorage.removeItem("autoLogin");
              localStorage.removeItem("kname");
              localStorage.removeItem("ename");
              alert("로그아웃 되었습니다.");
              router.push("/login");
            } else {
              alert("로그아웃 실패");
              return false;
            }
          });
      }
    },

    goImooc: function() {
      const url =
        "http://admin.imooc.co.kr/rest/auth/login?kname=" +
        localStorage.getItem("kname") +
        "&email=" +
        localStorage.getItem("uid");
      let wnd = window.open(url);
      setTimeout(function() {
        wnd.location.href = "https://admin.imooc.co.kr/admin/curation/list";
      }, 500);
    },

    /**
     * @description 라우터 푸시
     */
    goPage(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/commons/incMenu.vue